var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22748 7.22699C7.52038 6.9341 7.99525 6.9341 8.28814 7.22699L16.7734 15.7123C17.0663 16.0052 17.0663 16.48 16.7734 16.7729C16.4805 17.0658 16.0057 17.0658 15.7128 16.7729L7.22748 8.28765C6.93459 7.99476 6.93459 7.51989 7.22748 7.22699Z",
    fill: "#571BCE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7734 7.22699C17.0663 7.51989 17.0663 7.99476 16.7734 8.28765L8.28814 16.7729C7.99525 17.0658 7.52038 17.0658 7.22748 16.7729C6.93459 16.48 6.93459 16.0052 7.22748 15.7123L15.7128 7.22699C16.0057 6.9341 16.4805 6.9341 16.7734 7.22699Z",
    fill: "#571BCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c7640b012f54551122aa602f6de9f60e.svg";
export { ForwardRef as ReactComponent };